var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Message.prototype.render = function () {
        var _this = this;
        var _a = this.props, html = _a.html, className = _a.className, inline = _a.inline;
        if (inline) {
            return (React.createElement("span", { className: className, ref: function (element) { return (_this.element = element); }, dangerouslySetInnerHTML: { __html: html } }));
        }
        return (React.createElement("p", { className: className, ref: function (element) { return (_this.element = element); }, dangerouslySetInnerHTML: { __html: html } }));
    };
    return Message;
}(React.Component));
export default Message;



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/Message.tsx
// module id = 463
// module chunks = 81